import { Content } from "@radix-ui/react-accordion";
import type React from "react";

import { cn } from "@/lib/utils";

interface AccordionContentProps {
  className?: string;
  children: string | React.JSX.Element | React.JSX.Element[];
}
const AccordionContent = ({
  className = "",
  children,
  ...props
}: AccordionContentProps) => (
  <Content
    className="overflow-hidden transition-all data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down"
    {...props}
  >
    <div className={cn("pb-4 pt-0 px-4", className)}>{children}</div>
  </Content>
);

export { AccordionContent };
